// extracted by mini-css-extract-plugin
export default {"wrapper":"_4oN7psy7SXf7BSufUH9Q"};